// ============================================================
// Datei: src/pages/ressorts/infostand/InfostandMobile.jsx
//
// ÄNDERUNGEN:
// - Helferpool ergänzt
// - Unter "Libellen" jetzt 2 Untertabs:
//   1. Ressort
//   2. Helferpool
// - Extras-Tab ergänzt
// - bestehende Guest-Logik beibehalten
// - onEdit für VolunteerList ergänzt
// ============================================================

import React, { useState } from "react";

import VolunteerList from "../../../components/VolunteerList";
import VolunteerPool from "../../../components/VolunteerPool";
import ShiftTable from "../../../components/shiftTable/ShiftTable";

// Guests
import GuestRegistration from "../../../components/GuestRegistration";
import GuestList from "../../../components/guestList/GuestList";
import EditGuestModal from "../../../components/guestList/EditGuestModal";
import DeleteGuestModal from "../../../components/guestList/DeleteGuestModal";

import "./infostandMobile.css";

const InfostandMobile = ({
    volunteers,
    setVolunteers,
    shifts,
    guests,
    activeTab,
    setActiveTab,
    reloadGuests,
    reloadVolunteers,
    setSelectedVolunteer,
    downloadCcEmails
}) => {
    // ============================================================
    // STATE
    // ============================================================
    const [guestToEdit, setGuestToEdit] = useState(null);
    const [guestToDelete, setGuestToDelete] = useState(null);

    // Untertab für Libellen
    const [helpersSubTab, setHelpersSubTab] = useState("ressort");

    // ============================================================
    // SHIFTS
    // ============================================================
    const infostand = shifts.filter(
        (s) => s.shiftId >= 700 && s.shiftId <= 719
    );

    // ============================================================
    // TABS
    // ============================================================
    const tabs = [
        { id: "overview", label: "Übersicht" },
        { id: "helpers", label: "Libellen" },
        { id: "shifts", label: "Schichtplan" },
        { id: "guests", label: "Gästeliste" },
        { id: "extras", label: "Extrawürscht" }
    ];

    return (
        <>
            <div className="tabs-container">
                <div className="tab-bar">
                    {tabs.map((t) => (
                        <button
                            key={t.id}
                            type="button"
                            className={
                                "tab-button" +
                                (activeTab === t.id ? " tab-button-active" : "")
                            }
                            onClick={() => setActiveTab(t.id)}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>

                <div className="tab-panels">
                    {/* ================= HELPERS ================= */}
                    {activeTab === "helpers" && (
                        <div className="infostand-mobile-helpers-panel">
                            <div className="helpers-subtab-bar">
                                <button
                                    type="button"
                                    className={
                                        "helpers-subtab-button" +
                                        (helpersSubTab === "ressort"
                                            ? " helpers-subtab-button-active"
                                            : "")
                                    }
                                    onClick={() => setHelpersSubTab("ressort")}
                                >
                                    Ressort
                                </button>

                                <button
                                    type="button"
                                    className={
                                        "helpers-subtab-button" +
                                        (helpersSubTab === "pool"
                                            ? " helpers-subtab-button-active"
                                            : "")
                                    }
                                    onClick={() => setHelpersSubTab("pool")}
                                >
                                    Helferpool
                                </button>
                            </div>

                            {helpersSubTab === "ressort" && (
                                <VolunteerList
                                    volunteers={volunteers}
                                    setVolunteers={setVolunteers}
                                    onEdit={setSelectedVolunteer}
                                    reloadVolunteers={reloadVolunteers}
                                />
                            )}

                            {helpersSubTab === "pool" && (
                                <VolunteerPool
                                    departmentName="Infostand"
                                    onAssigned={() => {
                                        if (reloadVolunteers) {
                                            reloadVolunteers();
                                        }
                                    }}
                                />
                            )}
                        </div>
                    )}

                    {/* ================= SHIFTS ================= */}
                    {activeTab === "shifts" && (
                        <>
                            <h2 className="infostand-subheading">Infostand</h2>
                            <ShiftTable shifts={infostand} />
                        </>
                    )}

                    {/* ================= GUESTS ================= */}
                    {activeTab === "guests" && (
                        <>
                            <GuestRegistration refreshGuestList={reloadGuests} />

                            <GuestList
                                guests={guests}
                                refreshGuestList={reloadGuests}
                                onEdit={(g) => setGuestToEdit(g)}
                                onDelete={(g) => setGuestToDelete(g)}
                            />
                        </>
                    )}

                    {/* ================= EXTRAS ================= */}
                    {activeTab === "extras" && (
                        <div
                           >
                        </div>
                    )}
                </div>
            </div>

            {/* ================= EDIT GUEST ================= */}
            {guestToEdit && (
                <EditGuestModal
                    guest={guestToEdit}
                    onClose={() => setGuestToEdit(null)}
                    onSaved={() => {
                        setGuestToEdit(null);
                        reloadGuests();
                    }}
                />
            )}

            {/* ================= DELETE GUEST ================= */}
            {guestToDelete && (
                <DeleteGuestModal
                    guest={guestToDelete}
                    onClose={() => setGuestToDelete(null)}
                    onDeleted={() => {
                        setGuestToDelete(null);
                        reloadGuests();
                    }}
                />
            )}
        </>
    );
};

export default InfostandMobile;